// extracted by mini-css-extract-plugin
export default {"edit":"lpYkEXAv6P0HdxK5EXzd","delete":"Z_5nZVaU0d4mLoc3iM9u"};